import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import telemetry from 'legacy/src/utility/telemetry';
import RichText from 'legacy/src/utility/RichText';

import { submittable } from '../shared/status';
import Feedback from '../shared/Feedback';
import './essay_score.scss';

@telemetry({})
class Player extends Component {
  static propTypes = {
    item: PropTypes.object,
    submission: PropTypes.object,
    feedback: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.onSetScore = this.onSetScore.bind(this);
  }

  /**
   * Called when timer is updated
   **/
  @telemetry((props, state, args) => {
    const { item, params } = props;
    const [index] = args;
    const item_type_frq =
      item.description && item.description.type === 'doc'
        ? 'questions/free_response'
        : '';
    const item_type = item.type || item_type_frq;

    return {
      event_type: 'score_answer_rubric',
      params: {
        score: index,
        item: item.id,
        item_type,
        subject_id: params.subject,
        submission_id: params.submissionId,
        assignment_id: params.assignmentId,
      },
    };
  })
  onSetScore() {
    // This is just a placeholder to get the telemetry decorator triggered
    return true;
  }

  render() {
    const { submission, feedback } = this.props;
    const { prompt, answers, allow_post_submit_updates } =
      this.props.item.content;
    const { selection, submitted } = submission.state;

    const guidelines =
      selection === undefined || !answers[selection]
        ? prompt
        : answers[selection].description;

    return (
      <div className="essay_score" data-am-type="questions/essay_score">
        <div className="score__input">
          {answers.map((score, index) => {
            const selected = selection === index;
            const labelProps = {
              style: { width: `${100 / answers.length}%` },
              className: cn('score__option', { selected }),
            };
            const inputProps = {
              disabled: submitted && !allow_post_submit_updates,
              checked: selected,
              onChange() {
                submission.setState({ selection: index, submitted: false });
              },
            };
            // The index is only an option for backwards-compatability;
            // If we confirm all content is updated at some point, we can
            // remove it. Updated essay score items will have a "value"
            // property for each answer.
            return (
              <label key={index} {...labelProps}>
                <input
                  type="radio"
                  {...inputProps}
                  onClick={() => this.onSetScore(index)}
                />
                {score.value ? score.value : index}
                {index === feedback.correct_answer ? (
                  <div className="score__correct_score">Correct Score</div>
                ) : null}
              </label>
            );
          })}
        </div>
        {guidelines && !submitted && (
          <RichText content={guidelines} className="score__guide" />
        )}
        {submitted && <Feedback {...this.props} />}
      </div>
    );
  }
}

Player.displayName = 'EssayScore';

export default { Player, status: submittable };
